
import { Component, Vue } from 'vue-property-decorator';
import {
  CronFilterInterface,
  CronSettingsRepositoryInterface, TicketFiltersInterface,
} from '@/services/QA/cron-settings/interfaces';
import { DataTableHeader } from 'vuetify';
import Themeable from 'vuetify/lib/mixins/themeable';
import DeleteFilterDialog from '@/components/dialogs/qa/cron/DeleteFilterDialog.vue';

@Component({
  mixins: [
    Themeable,
  ],
  inject: [
    'cronSettingsRepository',
  ],
  components: {
    DeleteFilterDialog,
  },
})
export default class AllSettings extends Vue {
  private cronSettingsRepository!: CronSettingsRepositoryInterface;
  private settings: CronFilterInterface[] = [];
  private loading: boolean = true;
  private search: string = '';
  private deleteFilterForDialog: CronFilterInterface | false = false;
  private deleteFilterDialog: string = '';

  private ticketFiltersMap: TicketFiltersInterface = {
    name: 'Client Name',
    email: 'Client Email',
    status: 'Ticket Status',
    department: 'Department',
    client_id: 'Client ID',
  };

  private headers: DataTableHeader[] = [
    { text: 'ID', value: 'id' },
    { text: 'Property', value: 'property' },
    { text: 'Value', value: 'value' },
    { text: 'Actions', value: 'actions', sortable: false },
  ];

  private async created(): Promise<void> {
    await this.initialize();
  }

  private async initialize(): Promise<void> {
    this.settings = await this.cronSettingsRepository.getCronFilters();
    this.loading = false;
  }

  private async createSettings(): Promise<void> {
    await this.$router.push({ name: 'create_cron_settings' });
  }

  private async editFilter(id: number): Promise<void> {
    await this.$router.push({ path: `cron/edit/${id}` });
  }

  private async deleteFilter(filter: CronFilterInterface): Promise<void> {
    this.deleteFilterDialog = 'delete-filter-dialog';
    this.deleteFilterForDialog = filter;
  }
}
